import type { MouseEvent } from 'react'
import { ButtonLink, type ButtonLinkProps } from '@/components/ui/ButtonLink'
import { trackStartClubCta, type StartClubCtaSource } from '@/lib/analytics/startClubCta'

export type StartClubCtaProps = ButtonLinkProps & {
  /** The surface this CTA sits on — see StartClubCtaSource. */
  source: StartClubCtaSource
  /** Pricing-tier name, only where the CTA lives inside a plan card. */
  plan?: string
}

/**
 * A ButtonLink that reports its click to the club-signup funnel. Drop-in
 * replacement: every ButtonLink prop (variant, size, className, to) passes
 * through untouched, so the button looks and behaves exactly as before.
 */
export function StartClubCta({ source, plan, onClick, ...rest }: StartClubCtaProps) {
  return (
    <ButtonLink
      {...rest}
      onClick={(event: MouseEvent<HTMLAnchorElement>) => {
        trackStartClubCta(source, plan)
        onClick?.(event)
      }}
    />
  )
}
